module.exports = __webpack_public_path__ + "img/w3_bookmark_light.8bb0c6eb.png";